import { type LBNodeData } from '@/proto/logiblocks/logiblocks';
import { TRIGGER_ICON_COLOR } from '../../styles';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { TruckIcon } from '@/assets/icons/icons';
import { StatusProgressTriggerCustomization } from './StatusProgressTriggerCustomization';
import { defaultNodeData } from '../../graphUtils';

//TODO : add output variables and validations errors

export const StatusProgressTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'status_progress_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Status Progress',

  hasInput: false,

  getIcon: (size: number) => (
    <TruckIcon color={TRIGGER_ICON_COLOR} width={size} height={size} />
  ),

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const d = data.status_progress_trigger;
    if (!d) return '';

    if (d?.select_all === true) {
      return 'All';
    }

    const hasFilters =
      (d.courier_ids?.length ?? 0) > 0 ||
      (d.team_ids?.length ?? 0) > 0 ||
      (d.origin_ids?.length ?? 0) > 0 ||
      (d.destination_ids?.length ?? 0) > 0 ||
      (d.product_ids?.length ?? 0) > 0 ||
      d.select_all_origins ||
      d.select_all_teams ||
      d.select_all_destinations ||
      d.select_all_products ||
      d.select_all_transport_providers;
    return hasFilters ? 'Filtered' : '';
  },

  CustomizationComponent: StatusProgressTriggerCustomization,

  createDefaultNodeData: () =>
    defaultNodeData('status_progress_trigger', {
      select_all: false,
      courier_ids: [],
      team_ids: [],
      origin_ids: [],
      destination_ids: [],
      product_ids: [],
      select_all_teams: false,
      select_all_origins: false,
      select_all_products: false,
      select_all_transport_providers: false,
      select_all_destinations: false,
      is_pickup_confirmation: false,
      is_delivery_confirmation: false,
      is_delivery_exception: false,
      is_created: false,
      is_out_for_delivery: false,
      is_incomplete: false,
    }),
};
